export default function (string) {
  let result = '';

  if (!string) {
    return result;
  }

  try {
    result = encodeURIComponent(string);
  } catch {
    result = string;
  } finally {
    return result;
  }
};
